import { Tabs, TabsProps } from 'antd';
import React from 'react';
import './PageTabs.scss';

export interface PageTabsProps extends TabsProps {}

export function PageTabs(props: PageTabsProps) {
  return <Tabs className="page-content-tabs" {...props} />;
}
